import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Filter, X } from 'lucide-react';

const LOGIN_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'never', label: 'Never logged in' },
  { value: '7', label: '> 7 days ago' },
  { value: '30', label: '> 30 days ago' },
  { value: '90', label: '> 90 days ago' },
];

const AUTOMATA_FILTERS = [
  { value: 'all', label: 'All' },
  { value: 'none', label: 'No automata' },
  { value: 'has', label: 'Has automata' },
];

const ROLE_FILTERS = [
  { value: 'not_admin', label: 'Not Admin' },
  { value: 'all', label: 'All' },
  { value: 'admin', label: 'Admin' },
];

export function UserFilters({
  loginFilter, setLoginFilter,
  automataFilter, setAutomataFilter,
  roleFilter, setRoleFilter,
  activeTab,
  hasActiveFilters, clearFilters,
  filteredCount, totalCount,
}) {
  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="filter-bar">
      <Filter className="w-4 h-4 text-muted-foreground shrink-0" />
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground whitespace-nowrap">Last login:</span>
        <Select value={loginFilter} onValueChange={setLoginFilter}>
          <SelectTrigger className="h-8 w-[160px] text-xs" data-testid="filter-login">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {LOGIN_FILTERS.map(f => (
              <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground whitespace-nowrap">Automata:</span>
        <Select value={automataFilter} onValueChange={setAutomataFilter}>
          <SelectTrigger className="h-8 w-[140px] text-xs" data-testid="filter-automata">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {AUTOMATA_FILTERS.map(f => (
              <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {activeTab === 'active' && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground whitespace-nowrap">Role:</span>
          <Select value={roleFilter} onValueChange={setRoleFilter}>
            <SelectTrigger className="h-8 w-[130px] text-xs" data-testid="filter-role">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {ROLE_FILTERS.map(f => (
                <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      {hasActiveFilters && (
        <button
          onClick={clearFilters}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
          data-testid="clear-filters-btn"
        >
          <X className="w-3 h-3" /> Clear
        </button>
      )}
      {hasActiveFilters && (
        <span className="text-xs text-muted-foreground ml-auto" data-testid="filter-count">
          Showing {filteredCount} of {totalCount} users
        </span>
      )}
    </div>
  );
}
